<script>
import { authComputed } from '@state/helpers'
import filterArrayByValue from '@utils/filter-array-by-value'
import { groupByKey } from '@utils'

import TheHeader from './TheHeader'
import menuList from './sidemenu'

export default {
  components: { TheHeader },
  data() {
    return {
      current: ['home'],
      collapsed: true,
      menus: [],
    }
  },
  computed: {
    ...authComputed,
    userMenuList() {
      const userMenu = filterArrayByValue(menuList, this.currentUserRoutes, 'name')

      return groupByKey(userMenu, 'group')
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<template>
  <div :class="[$style.wrapper, { [$style['wrapper--collapsed']]: !collapsed }]">
    <template v-if="loggedIn">
      <div :class="$style.sidebar">
        <div :class="$style.logo">
          <img src="~@assets/images/ibobee_logo.png" srcset="~@assets/images/ibobee_logo@2x.png 2x" alt />
        </div>

        <el-menu :collapse="collapsed" :class="$style.menu">
          <div v-for="(group, groupNumber) in userMenuList" :key="groupNumber" :class="$style['menu__group']">
            <router-link v-for="menu in group" :key="menu.name" :to="{ name: menu.name }" :class="$style['menu__link']">
              <el-menu-item :class="$style['menu__item']" :welcome-guide-title="menu.title" :welcome-guide-intro="menu.description">
                <BaseIcon :name="menu.icon" />
                <span slot="title">{{ menu.title }}</span>
              </el-menu-item>
            </router-link>
          </div>
        </el-menu>
      </div>
      <div :class="$style.content">
        <TheHeader :collapsed="collapsed" @toggle="toggle" />
        <el-main :class="$style.main">
          <slot />
        </el-main>
      </div>
    </template>

    <el-main v-else :class="$style.main">
      <slot />
    </el-main>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.sidebar {
  position: absolute;
  z-index: $layer-sidebar-z-index;
  height: 100%;
  background-color: $color-sidebar-bg;
  transition: width 0.3s;
  top: 0;
  left: 0;

  .menu {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - #{$size-header-height});
    background-color: $color-sidebar-bg;
    border-right: none;

    &::before,
    &::after {
      display: none;
    }

    &__item {
      color: white;
      text-align: center;
      &:hover {
        background: $color-primary-gradient;
      }
      i {
        color: white;
      }
    }
    &__link {
      &:global(.router-link-active) .menu__item {
        background: $color-primary-gradient;
      }
    }
  }
}

.content {
  margin-left: $size-sidebar-width;
  transition: margin-left 0.28s;
}

.wrapper {
  &--collapsed {
    .sidebar {
      width: 200px;
    }
    .content {
      margin-left: 200px;
    }
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: $size-header-height;
  background: #bf7e45;
  img {
    // height: $size-header-height - 20px;
    height: 60px;
    width: 64px;
  }
}

.main:global(.el-main) {
  position: relative;
  padding-top: $size-header-height + 20px;
}
</style>
